import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import * as JSXRuntime from 'react/jsx-runtime';

window.React = React;
window.ReactDOM = ReactDOM;
window.JSXRuntime = JSXRuntime; 